/**
 * Post meal-rating journey helpers.
 *
 * Keeps MealRatingPopup free of follow-up copy / routing.
 *
 * Shared entry point for opening the rating flow from anywhere:
 *   MealRatingJourney.openLastOrderRating({ source, onClose, beforeFollowUp, context })
 *
 * Ratio = good_count / rated_count (unrated ignored).
 *   rated_count === 0              → none
 *   good_ratio < 0.5               → sorry + leave a comment
 *   good_ratio === 0.5             → thanks + refer OR leave a comment
 *   0.5 < ratio < 0.7              → refer + Trustpilot
 *   good_ratio >= 0.7              → refer + Trustpilot (glad messaging)
 */
(function () {
  var TRUSTPILOT_URL = 'https://uk.trustpilot.com/review/www.fuelhub.co.uk';
  var REFERRAL_URL = '/account?view=referral';

  var RULES = {
    gladMin: 0.7
  };

  function isExactHalf(stats) {
    return stats.rated_count > 0 && stats.good_count * 2 === stats.rated_count;
  }

  function getRatingStats(payload) {
    var source = payload || {};
    var ratings = Array.isArray(source.ratings) ? source.ratings : [];
    var goodCount = 0;
    var badCount = 0;

    ratings.forEach(function (item) {
      if (item && item.rate === 'good') goodCount += 1;
      if (item && item.rate === 'bad') badCount += 1;
    });

    var ratedCount =
      typeof source.rated_count === 'number' ? source.rated_count : goodCount + badCount;
    var totalCount =
      typeof source.total_count === 'number' ? source.total_count : ratings.length;

    return {
      good_count: goodCount,
      bad_count: badCount,
      rated_count: ratedCount,
      total_count: totalCount,
      good_ratio: ratedCount > 0 ? goodCount / ratedCount : 0
    };
  }

  function referCard() {
    return {
      id: 'refer-a-friend',
      textMedia: true,
      mediaIcon: 'gift',
      title: 'REFER A FRIEND',
      description: 'Give a friend £10 off and get £10 credit!',
      ctaLabel: 'REFER NOW',
      href: REFERRAL_URL
    };
  }

  function commentCard() {
    return {
      id: 'leave-comment',
      textMedia: true,
      mediaIcon: 'comment',
      title: 'LEAVE US A COMMENT',
      description: 'Tell us more about your experience.',
      ctaLabel: 'LEAVE A COMMENT',
      hasCommentBox: true
    };
  }

  function trustpilotCard() {
    return {
      id: 'leave-review',
      textMedia: true,
      mediaIcon: 'star',
      title: 'LEAVE US A REVIEW',
      description: 'Tell others why you love FuelHub.',
      ctaLabel: 'REVIEW ON TRUSTPILOT',
      href: TRUSTPILOT_URL,
      external: true
    };
  }

  function getNextRatingAction(stats) {
    var s = stats || getRatingStats({});

    if (!s.rated_count) {
      return {
        id: 'none',
        label: 'No ratings submitted',
        stats: s
      };
    }

    // Exactly 50%: thanks + refer OR comment
    if (isExactHalf(s)) {
      return {
        id: 'mixed_feedback',
        label: 'Refer or leave a comment',
        stats: s,
        title: 'Thanks for your feedback!',
        subtitle: 'Refer a friend or leave us a comment.',
        cards: [referCard(), commentCard()]
      };
    }

    // Below 50%
    if (s.good_ratio < 0.5) {
      return {
        id: 'comments',
        label: 'Comments / contact',
        stats: s,
        title: 'Sorry, this isn’t the experience we aim to deliver.',
        subtitle: '',
        cards: [commentCard()]
      };
    }

    // 70%+
    if (s.good_ratio >= RULES.gladMin) {
      return {
        id: 'refer_review_glad',
        label: 'Refer + Trustpilot',
        stats: s,
        title: 'We’re glad you enjoyed!',
        subtitle:
          'Share the love with a friend, or leave us a quick review on Trustpilot.',
        cards: [referCard(), trustpilotCard()]
      };
    }

    // More than 50%, below 70%
    return {
      id: 'refer_review',
      label: 'Refer + Trustpilot',
      stats: s,
      title: 'Thanks for your feedback!',
      subtitle: 'Glad your meals went down well. Share FuelHub or leave us a quick review.',
      cards: [referCard(), trustpilotCard()]
    };
  }
  function handleFollowUpCardClick(card, index, detail) {
    if (!card) return;

    if (card.id === 'leave-comment') {
      submitComment(card, detail);
      return;
    }

    if (card.external && card.href) {
      window.open(card.href, '_blank', 'noopener,noreferrer');
      return;
    }

    if (card.href) {
      window.location.href = card.href;
    }
  }

  function submitComment(card, detail) {
    var comments = (detail && detail.comments) || '';
    var cardEl =
      window.CtaPopup &&
      window.CtaPopup.gridEl &&
      window.CtaPopup.gridEl.querySelector('[data-cta-popup-card="leave-comment"]');
    var button = cardEl && cardEl.querySelector('.cta-popup__card-cta');

    if (!comments) {
      console.warn('[MealRatingJourney] comment skipped — empty text');
      if (cardEl) {
        var input = cardEl.querySelector('[data-cta-comment-input]');
        if (input) input.focus();
      }
      return;
    }

    if (cardEl && cardEl.classList.contains('is-sending')) return;

    if (cardEl) cardEl.classList.add('is-sending');
    if (button) {
      button.disabled = true;
      button.textContent = 'SENDING…';
    }

    window.MealRatingJourney.saveComments(comments)
      .then(function (data) {
        console.log('[MealRatingJourney] save_comments succeeded', data);
        if (cardEl) {
          cardEl.classList.remove('is-sending');
          cardEl.classList.add('is-sent');
        }
        if (button) button.textContent = 'THANK YOU';
        setTimeout(function () {
          if (window.CtaPopup) window.CtaPopup.hide();
        }, 900);
      })
      .catch(function (error) {
        console.error('[MealRatingJourney] save_comments failed', error);
        if (cardEl) cardEl.classList.remove('is-sending');
        if (button) {
          button.disabled = false;
          button.textContent = card.ctaLabel || 'LEAVE A COMMENT';
        }
      });
  }

  function showFollowUp(action) {
    if (!action || action.id === 'none') {
      console.log('[MealRatingJourney] no follow-up popup', action);
      return;
    }

    if (!window.CtaPopup) {
      console.warn('[MealRatingJourney] CtaPopup is not available');
      return;
    }

    window.CtaPopup.show({
      title: action.title,
      subtitle: action.subtitle,
      cards: action.cards,
      onCardClick: handleFollowUpCardClick
    });
  }

  function afterConfirm(payload) {
    window.MealRatingJourney.lastPayload = payload || null;

    var stats = getRatingStats(payload);
    var action = getNextRatingAction(stats);

    console.log('[MealRatingJourney] selected journey', {
      id: action.id,
      label: action.label,
      stats: action.stats
    });

    showFollowUp(action);
    return action;
  }

  /**
   * Single reusable entry point for the Meal Rating flow.
   *
   * Gets the last rateable order, opens MealRatingPopup, and wires confirm
   * to afterConfirm (follow-up CTAs). Callers only pass optional hooks.
   *
   * options:
   *   source          {string}   console log label (default: MealRatingJourney)
   *   context         {object}   extra fields merged into the open log
   *   onClose         {function} when customer closes without confirming
   *   beforeFollowUp  {function} runs before afterConfirm(payload)
   *
   * @returns {boolean} true if the rating popup opened
   */
  function openLastOrderRating(options) {
    var opts = options || {};
    var source = opts.source || 'MealRatingJourney';
    var params = new URLSearchParams(window.location.search);
    var includeRated = !!opts.includeRated || params.has('meal_rating_all');

    if (!window.MealRatingPopup) {
      console.warn('[' + source + '] MealRatingPopup is not available');
      return false;
    }

    var rateable = window.MealRatingPopup.getLastRateableOrder();
    var openLog = {
      has_last_order: !!rateable,
      order_id: rateable && rateable.order && rateable.order.order_id,
      order_name: rateable && rateable.order && rateable.order.order_name,
      meal_count: rateable ? rateable.meals.length : 0
    };

    if (opts.context && typeof opts.context === 'object') {
      Object.keys(opts.context).forEach(function (key) {
        openLog[key] = opts.context[key];
      });
    }

    console.log('[' + source + '] opening meal rating', openLog);

    if (!rateable) {
      console.warn('[' + source + '] no last rateable order');
      return false;
    }

    window.MealRatingPopup.show({
      order: rateable.order,
      meals: rateable.meals,
      includeRated: includeRated,
      onConfirm: function (payload, response) {
        console.log('[' + source + '] save_batch succeeded', payload, response);
        if (typeof opts.beforeFollowUp === 'function') {
          opts.beforeFollowUp(payload);
        }
        afterConfirm(payload);
      },
      onClose: typeof opts.onClose === 'function' ? opts.onClose : null
    });

    return true;
  }

  function openOrderFromHistory(orderEl, seedRating) {
    if (!window.MealRatingPopup || !orderEl) return false;

    var orderId = String(orderEl.id || '').replace(/^order_/, '');
    var orders = window.MealRatingPopup.getAllOrdersFromAccountPage();
    var found = null;

    for (var i = 0; i < orders.length; i += 1) {
      if (orders[i].order && String(orders[i].order.order_id) === orderId) {
        found = orders[i];
        break;
      }
    }

    if (!found) {
      console.warn('[Order History] could not build meals for order', orderId);
      return false;
    }

    console.log('[Order History] opening meal rating', {
      order_id: found.order.order_id,
      order_name: found.order.order_name,
      meal_count: found.meals.length,
      seed_rating: seedRating || null
    });

    window.MealRatingPopup.show({
      order: found.order,
      meals: found.meals,
      lockOrder: true,
      seedRating: seedRating || null,
      onConfirm: function (payload, response) {
        console.log('[Order History] save_batch succeeded', payload, response);
        afterConfirm(payload);
      }
    });

    return true;
  }

  window.MealRatingJourney = {
    RULES: RULES,
    lastPayload: null,
    getRatingStats: getRatingStats,
    getNextRatingAction: getNextRatingAction,
    showFollowUp: showFollowUp,
    afterConfirm: afterConfirm,
    openLastOrderRating: openLastOrderRating,
    openOrderFromHistory: openOrderFromHistory,
    saveComments: function (comments) {
      if (!window.MealRatingApi || typeof window.MealRatingApi.saveComments !== 'function') {
        return Promise.reject(new Error('MealRatingApi.saveComments is not available'));
      }
      return window.MealRatingApi.saveComments(window.MealRatingJourney.lastPayload || {}, comments);
    }
  };

  // Account nav: Rate my Meals
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-open-meal-rating]');
    if (link) {
      event.preventDefault();
      openLastOrderRating({ source: 'Rate my Meals' });
      return;
    }

    var thumb = event.target.closest('.item-meal__rating_item');
    if (!thumb) return;

    var orderEl = thumb.closest('.order-item[id^="order_"]');
    if (!orderEl) return;

    event.preventDefault();
    event.stopPropagation();

    var mealEl = thumb.closest('.item-meal');
    var rate = thumb.getAttribute('data-rate') || '';
    var mealIndex = -1;
    if (mealEl && orderEl) {
      var mealEls = orderEl.querySelectorAll('.item-meal[data-pid]');
      mealIndex = Array.prototype.indexOf.call(mealEls, mealEl);
    }
    openOrderFromHistory(orderEl, {
      product_id: mealEl ? mealEl.getAttribute('data-pid') : '',
      variant_id: mealEl ? mealEl.getAttribute('data-vid') : '',
      meal_index: mealIndex,
      rate: rate
    });
  });

  // Preview URLs (account pages, while this draft theme is previewed):
  //   /account?meal_rating=1
  //     Opens the rating popup on load.
  //   /account?meal_rating=1&meal_rating_all=1
  //     Same, but includes already-rated orders so left/right arrows can be demoed.
  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('meal_rating')) return;
    openLastOrderRating({
      source: 'MealRatingJourney preview',
      includeRated: params.has('meal_rating_all')
    });
  });
})();
